import React, { useState, useEffect, useCallback, useRef } from "react";

import { useNavigate } from "react-router-dom";

//components
import DataTable from "../../../../components/Tables/DataTable";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
//hooks
import useLazyQueryAuth from "../../../../hooks/useLazyQueryAuth";
import useQueryAuth from "../../../../hooks/useQueryAuth";
import useAuth from "../../../../hooks/useAuth";
import ConfirmationModal from "../../../../components/Modal/ConfirmationModal";
import PaperComponent from "../../../../components/Modal/PaperComponent";

//graphql
import {
  GET_ALL_TIMESHEETS,
  DELETE_TIMESHEET,
  RENAME_TIMESHEET,
  GET_TIMESHEET_DESCRIPTION,
  APPROVE_PENDING_TIMESHEET,
  SEND_TIMESHEET_APPROVAL_NOTIFICATION,
} from "../../../../graphql/timesheet";
import { GET_USER_TABLE_PREFERENCES } from "../../../../graphql/userTablePreferences";
import { GET_ALL_PROJECTS_DROPDOWN } from "../../../../graphql/project";

//editors
import { Parse } from "../../../../JSON.editor";

//mnemonic values
import Mnemonic from "../../../../Mnemonics.json";

import { UTC2Time, formatDateTimeToString } from "../../../../UTC2Local";

import urls from "../../../../urls";

//external components
import { CircularProgress, Box, Grid, IconButton, Dialog, TextField, Typography } from "@mui/material";

import ContainerCard from "../../../../components/Cards/ContainerCard";
import UTC2Local from "../../../../UTC2Local";
import componentDisplay from "../../../../componentDisplay";
import { useSnackbar } from "notistack";

import { useTranslation } from "react-i18next";
import TaskTabsModal from "../../../../components/Modal/TaskTabsModal";
import CustomButton from "../../../../components/CustomButton";
import { CloseIcon, DeleteIcon, EditIcon, RefreshIcon } from "../../../../components/Icon";
import { LOGOUT_USER } from "../../../../graphql/user";
import * as FileSaver from "file-saver";
import IALoadingButton from "../../../../components/IAButtons/IALoadingButton";
import { useDispatch } from "react-redux";
import colors from "../../../../assets/theme/light/colors";

import apiCall from "../../../../hooks/useRest";
import { saveToken } from "../../../../app/reducers/tokenSlice";
import useMutationAuth from "../../../../hooks/useMutationAuth";
import { removeNullProps } from "../../../../utils/removeNullProps";
import { decodeUnicodeString } from "../../../../utils/decodeUnicodeString";
const backendURL = process.env.REACT_APP_REST_URL;

const MonthyTimesheet = () => {
  const navigate = useNavigate();

  const { my_created_timesheets, my_approved_timesheet_form, my_approved_timesheets, my_pending_timesheet_form, edit_pending_timesheet } = urls;

  const {
    storeUserGuid,
    storeUserTenant,
    userRoles,
    syncTimeEntry,
    allowTimesheetReopening,
    logout
  } = useAuth();

  const { manageTimeEntry } = userRoles;


  const { t } = useTranslation();
  const { dark_logo_blue } = colors;
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const redValue = "var(--color-error)";
  const [data, setData] = useState(null);
  const [defaultFilters, setDefaultFilters] = useState({});
  const [columns, setColumns] = useState([]);
  const [linkCell, setLinkCell] = useState(false);
  const [openApprovedDialog, setOpenApproveDialog] = useState(false);
  const [re, setRe] = useState(false);
  const [description, setDescription] = useState("")
  const [order, setOrder] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState([]);
  const [taskID, setTaskID] = useState(null);
  const [projectID, setProjectID] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [removeSheet, setRemoveSheet] = useState(false);
  const type = useRef("task");
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openApproveRequestDialog, setOpenApproveRequestDialog] = useState(false)
  const [triggerTimesheetQuery, setTriggerTimesheetQuery] = useState(false);
  const [projectGuid, setProjectGuid] = useState([])
  const [fetchProjects, setFetchProjects] = React.useState(false);
  const [projectsList, setProjectsList] = React.useState([]);
 

  const [TimeEntries, setTimeEntries] = useState([])
  useEffect(() => {
    if (selected.length > 0) {
        const timesheetsInfo = selected.map(selectedId => {
            const matchingTimesheetGuids = data.GetTimeSheetList.timeSheetList.timeSheets.find(
                timesheet => timesheet.timeSheetGuid === selectedId
            );

            if (matchingTimesheetGuids) {
                setProjectGuid(matchingTimesheetGuids.projectGuids)
                setTimeEntries(matchingTimesheetGuids.timeEntries)
            } else {
                return null;
            }
        })
    }
}, [selected]);

  const timeSheetGuid = React.useRef(null);
  const [exportLoading, setExportLoading] = useState(false);
  const { mfunction: logsOutUser } = useMutationAuth(LOGOUT_USER, "LogoutUser");
  const updateToken = (updatedToken) => {
    if (updatedToken) dispatch(saveToken(updatedToken))
  }
  const {
   
    mfunction: getProjects,
    loading: projectLoading,
    tokenChange: projectsWait,
  } = useLazyQueryAuth(GET_ALL_PROJECTS_DROPDOWN, "GetAllProjects");

  useEffect(() => {
    if (fetchProjects) {
      getProjects(
        {
          variables: {
            model: {
              enableFilters: false,
              tenantID: storeUserTenant,
              userID: storeUserGuid,
              
            },
          },
          skip: !fetchProjects,
          isWait: fetchProjects,
        },
        (response) => {
          
          setProjectsList(
            response?.GetAllProjects?.projectsList?.projectViews || []
          );
        }
      );
    }
  }, [fetchProjects]);
 


  const checkIfUniqueProject = () => {
    if (projectGuid.length && TimeEntries.length !== 0) {
      return true;
    }
  
    // If not, check consistency among timeEntries' projectGuids
    if (TimeEntries.length === 0) {
      enqueueSnackbar(t("timesheet.send.approval.no.timeentries"), {
        variant: "error",
        autoHideDuration: 5000
      });
      
      return false;
    }
    return true;
  };
  


  const {
    data: timesheetData,
    loading: timesheetLoading,
    tokenChange: timesheetWait,
  } = useQueryAuth(GET_TIMESHEET_DESCRIPTION, "GetTimesheetDescription", {
    skip: selected?.length === 0 || !triggerTimesheetQuery,
    variables: {
      id: selected[0],
    },

  });

  const timesheetDescription = timesheetData?.GetTimesheetDescription?.description

  useEffect(() => {

    if (timesheetDescription) {
      setDescription(timesheetDescription)
    }
  }, [timesheetDescription]);


  const filtersObject = [
    {
      label: "timesheet.list.filters.projects",
      name: "projectIDs",
      type: "multiple",
      getOptionLabel: (option) => (option ? option.title : ""),
      options: projectsList,
      access: "projectGuid",
      loading: projectLoading,
      fetchData: setFetchProjects
    },
    {
      type: "date",
      label: "timesheet.list.filters.dateFrom",
      name: "dateFrom",
    },
    {
      type: "date",
      label: "timesheet.list.filters.dateTo",
      name: "dateTo",
    },
  ];

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleSave = () => {
    handleRemove();
    timeSheetGuid.current = null;
    handleClose();
  };

  const handleOpenDeleteConfirmationModal = (flag) => {
    setRemoveSheet(flag);
    setOpenDialog(true);
  };

  useEffect(() => {
    function handleKeyDown(event) {
      if (event.key === "Escape") {
        setOpenDialog(false);
        setOpenApproveDialog(false)
      }
    }

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const { mfunction: deleteTimesheetRecord } = useMutationAuth(
    DELETE_TIMESHEET,
    "DeleteTimeSheet"
  );

  const {
    loading: getColumnsLoading,
    refetch: refetchColumns,
    tokenChange: columnsWait,
  } = useQueryAuth(
    GET_USER_TABLE_PREFERENCES,
    "GetUserTablePreferences",
    {
      variables: {
        model: {
          table: Mnemonic.Tables.MonthlyTimesheets,
          userID: storeUserGuid,
        },
      },
      skip: projectsWait,
      isWait: true
    },
    {
      onCompleted: (response) => {
        let col =
          response &&
            response.GetUserTablePreferences &&
            response.GetUserTablePreferences.columns
            ? response.GetUserTablePreferences.columns
            : null;

        if (col) {
          col = decodeUnicodeString(col);

          //we parse the json string to a json object
          const parsed = JSON.parse(col, (key, value) =>
            Parse(key, value, UTC2Local, componentDisplay, UTC2Time, null, null, formatDateTimeToString)
          );

          if (parsed.defaultSort) setOrderBy(parsed.defaultSort);

          if (parsed.defaultSortDirection)
            setOrder(parsed.defaultSortDirection);

          const colmns = parsed.columns;
          if (colmns) {
            colmns.forEach((col) => {
              col = removeNullProps(col);
              if (col.id === "date")
                return (col.renderCell = (row) => {
                  return formatDateTimeToString(row?.startTime, false);
                });
            });
            setLinkCell(colmns.some((col) => col.link === true));
            setColumns(colmns);
          }
        }
      },
    }
  );

  const {
    mfunction: getAllTimesheets,
    loading,
    refetch: refetchTimeSheet,
  } = useLazyQueryAuth(GET_ALL_TIMESHEETS, "GetTimeSheetList");

  const fetchTableData = useCallback(
    (
      page = 0,
      pageSize = 0,
      order = "",
      orderBy = "",
      search = "",
      filters = null
    ) => {
      getAllTimesheets(
        {
          variables: {
            model: {
              enableFilters: true,
              keys: {
                page: page + 1,
                pageSize: pageSize,
              },
              keyword: search,
              filters: filters,
              orderColumn: orderBy,
              orderDirection: order,
              tenantGuid: storeUserTenant,
              userID: storeUserGuid,
              monthly: true,
              pending: false,
            },
          },
          skip: timeSheetGuid.current === null,
          isWait: true,
        },
        (response) => {
          setData(response);
          setRows(
            response?.GetTimeSheetList?.timeSheetList?.timeSheets
          );
        }
      );
    },
    []
  );


  const records =
    data &&
      data.GetTimeSheetList &&
      data.GetTimeSheetList.timeSheetList &&
      data.GetTimeSheetList.timeSheetList.timeSheets
      ? data.GetTimeSheetList?.timeSheetList?.timeSheets
      : [];


  const numberRecords =
    data &&
      data.GetTimeSheetList &&
      data.GetTimeSheetList.timeSheetList &&
      data.GetTimeSheetList.timeSheetList.timeSheets &&
      data.GetTimeSheetList.timeSheetList.totalNumberOfRecords
      ? data.GetTimeSheetList.timeSheetList.totalNumberOfRecords
      : 0;

  useEffect(() => {
    if (!columnsWait)
      fetchTableData(page, rowsPerPage, order, orderBy, search, defaultFilters);
  }, [columnsWait, re]);


  const handleRemove = () => {
    deleteTimesheetRecord(
      {
        variables: {
          timesheetGuid: selected[0],
        },
      },
      (response) => {
        enqueueSnackbar(t("timesheet.list.delete.success"), {
          variant: "success",
        });
        setSelected([]);
        refetchTimeSheet();
      }
    );
  };

  const handleRefresh = () => {
    fetchTableData(page, rowsPerPage, order, orderBy, search, defaultFilters);
  };

  const customButtons = [
    {
      label: "timesheet.btn.refresh.label",
      handleClick: () => handleRefresh(),
      condition: true,
      icon: true,
      iconButton: <RefreshIcon color="#000000" />,
    },
    {
      label: "timesheet.btn.create.label",
      handleClick: () => {
        navigate(my_created_timesheets)
      },
      condition: manageTimeEntry === "M",
      icon: true,
      iconButton: (
        <AddCircleRoundedIcon
          sx={{
            color: "var(--color--light-logo-blue)",
            fontSize: "28px !important",
          }}
        />
      ),
    },
    {
      label: "timesheet.btn.remove.label",
      handleClick: () => handleOpenDeleteConfirmationModal(true),
      condition: selected && selected.length > 0 && !records.some((row) => row.timeSheetGuid === selected[0] && row.synced === true),
      icon: true,
      iconButton: (
        <DeleteIcon color={redValue} />
      ),
    },
    {
      label: "timesheet.user.button",
      handleClick: () => { setOpenEditDialog(true); setTriggerTimesheetQuery(true); },
      condition: selected && selected.length > 0,
      icon: true,
      iconButton: <EditIcon color="#000000" />,
    },
    {
      label: "timesheet.btn.sendApprover.label",
      handleClick: () => { setOpenApproveRequestDialog(true) },
      condition: selected && selected.length > 0,
      icon: true,
      iconButton: <svg xmlns="http://www.w3.org/2000/svg" color="#000000" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="24" height="24" stroke-width="1">
      <path d="M12 18h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5"></path>
      <path d="M3 6l9 6l9 -6"></path>
      <path d="M15 18h6"></path>
      <path d="M18 15l3 3l-3 3"></path>
    </svg>,
    disabled: !projectGuid
    },

  ];


  const { mfunction: approveTimesheet } = useMutationAuth(
    APPROVE_PENDING_TIMESHEET,
    "ApprovePendingTimesheet"
  );

  const handleApprove = () => {
    approveTimesheet(
      {
        variables: {
          model: {
            userGuid: storeUserGuid,
            timesheetGuid: timeSheetGuid,
          },
        },
      },
      (response) => {
        enqueueSnackbar(t("timesheet.approval.success"), {
          variant: "success",
        });
        navigate(my_approved_timesheets);
      }
    )
  };

  const handleApprovedClose = () => {
    setOpenApproveDialog(false);
  };
  const handleApproveSave = () => {
    handleApprove();
    handleClose();
  };


  const customModalButton = () => (
    <>
      <CustomButton onClick={handleApproveSave} label={t("dialog.yes")} />
      <div>
        <CustomButton onClick={handleApprovedClose} label={t("dialog.cancel")} />
      </div>
    </>
  );

  const { mfunction: updateRecords } = useMutationAuth(
    RENAME_TIMESHEET,
    "RenameTimesheet"
  );


  const handleUpdate = () => {
    updateRecords(
      {
        variables: {
          model: {
            timesheetGuid: selected[0],
            description: description,
          },
        },
      },
      () => {
        enqueueSnackbar(t("invoices.list.undo.success"), {
          variant: "success",
        });
        setOpenEditDialog(false)
        setRe((v) => !v);
        setSelected([]);
        setPage(0);
        setTriggerTimesheetQuery(false)

      }
    );
  };

  async function exportTimeToExcel() {
    setExportLoading(true);

    const res = await apiCall(
      backendURL + `/ExportExcel/exportMyApprovedTimeSheet`,
      "POST",
      records,
      logsOutUser,
      logout,
      updateToken,
      enqueueSnackbar,
      t,
      null,
      'blob'
    );

    if (res) {
      let fileName = "ApprovedTimeSheet" + Date.now() + ".xlsx"; // Default file name

      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const blob = new Blob([res.data], { type: fileType });

      FileSaver.saveAs(blob, fileName);
      enqueueSnackbar(t("report.exportSuccessfully"), { variant: "success" });

    }
    setExportLoading(false);

  }

  const pagination = {
    rows: records,
    setRows,
    columns,
    defaultFilters,
    setDefaultFilters,
    order,
    setOrder,
    orderBy,
    setOrderBy,
    selected,
    setSelected,
    search,
    filtersObject,
    // hideFilters: timeSheetGuid.current == null ? true : false,
    refetch: refetchColumns,
    setSearch,
    setPage,
    setRowsPerPage,
    numberRecords,
    page,
    rowsPerPage,
    // hideSearchBar: true,
    hideRefreshButton: true,
    hideAddButton: true,
    fetchTableData,
    loading: loading || getColumnsLoading,
    searchText: "timesheet.list.search.label",
    tableMnemonic: Mnemonic.Tables["MonthlyTimesheets"],
    readOnly: false || manageTimeEntry !== "M",
    // hideEditColumns: true,
    generateRoute: (row) => {
      if (row?.status === "Pending") {
        return edit_pending_timesheet.replace(
          "/:tName/:tID",
          `/${encodeURIComponent(row?.description)}/${encodeURIComponent(row?.timeSheetGuid)}?edit=true`
        );
      } else if (row?.status === "Approved") {
        return my_approved_timesheet_form.replace(
          "/:tName/:tID",
          `/${encodeURIComponent(row?.description)}/${encodeURIComponent(row?.timeSheetGuid)}?edit=true`
        );
      }
    },
    // removeFilters: true,
    removeRefresh: true,
    customButtons,
    keepFilters: true,
    linkCell,
  };

  const customModalButtons = () => (
    <>
      <CustomButton onClick={handleSave} label={t("dialog.yes")} />
      <div>
        <CustomButton onClick={handleClose} label={t("dialog.cancel")} />
      </div>
    </>
  );

  const { mfunction: sendApprovalRequest } = useMutationAuth(
    SEND_TIMESHEET_APPROVAL_NOTIFICATION,
    "SendTimesheetApprovalNotification"
  );

  const handleSendApprovalRequest = () => {
    sendApprovalRequest(
      {
        variables: {
          model: {
            timesheetGuid: selected[0]
        },
        },
      },
      (response) => {
        if (
          response["SendTimesheetApprovalNotification"].errorCode !== null &&
          response["SendTimesheetApprovalNotification"].errorCode !== ""
        ) {
          enqueueSnackbar(t("timesheet.sendApproval.error"), {
            variant: "error",
            autoHideDuration: 5000
          });
          handleCloseApprovalRequest()
          setSelected([])
        }else {
          enqueueSnackbar(t("timesheet.sendApproval.success"), {
            variant: "success",
          });
          setSelected([])
          handleCloseApprovalRequest()
        }
      },
      (error) => {
        enqueueSnackbar(t("timesheet.sendApproval.unknownError"), {
          variant: "error",
        });
        setSelected([])
      }
    );
  };
  const handleCloseApprovalRequest = () => {
    setOpenApproveRequestDialog(false)
  }


  const handleSaveApproveRequest = () => {
    if(checkIfUniqueProject()){
      handleSendApprovalRequest()
      setOpenApproveRequestDialog(false)
    }else {
      setOpenApproveRequestDialog(false)
    }

  }

  const customModalButtons2 = () => (
    <div>
      <CustomButton onClick={handleSaveApproveRequest} label={t("dialog.yes")} />
        <CustomButton onClick={handleCloseApprovalRequest} label={t("dialog.cancel")} />
      </div>
  )

  return (
    <div>
      <ConfirmationModal
        contentText={t("dialog.user.sheet.approve.confirmation")}
        title={t("dialog.warning")}
        icon={"warning"}
        openDialog={openApprovedDialog}
        handleClose={handleApprovedClose}
        customButtons={customModalButton}
        t={t}
      />
      <ConfirmationModal
        contentText={
          removeSheet
            ? t("dialog.user.delete.sheet.confirmation")
            : syncTimeEntry === true && allowTimesheetReopening === false
              ? t("dialog.user.sheet.approve.sync.time.entry.true.confirmation")
              : syncTimeEntry === false && allowTimesheetReopening === false
                ? t(
                  "dialog.user.sheet.approve.sync.time.entry.false.allow.sheet.reopening.false.confirmation"
                )
                : t("dialog.user.sheet.approve.confirmation")
        }
        title={t("dialog.warning")}
        icon={"warning"}
        openDialog={openDialog}
        handleClose={handleClose}
        customButtons={customModalButtons}
        t={t}
      />
            <ConfirmationModal
        contentText={t("dialog.user.sendApprover.sheet.confirmation")}
        title={t("dialog.warning")}
        icon={"warning"}
        openDialog={openApproveRequestDialog}
        handleClose={handleCloseApprovalRequest}
        customButtons={customModalButtons2}
        t={t}
      />

      {/* <Grid item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              sx={{ paddingTop: "10px", display: "flex", alignItems: "end",direction:"rtl" }}>
                <IALoadingButton
                onClick={() => exportTimeToExcel()}
                loading={loading}
                style={{
                  width: "fit-content",
                  backgroundColor: dark_logo_blue,
                  borderRadius: "50px",
                  height: "36px",
                  marginRight: "10px",
                }}
                label={t("exportTimeSheet")}
                disabled={!rows || exportLoading ||rows.length<1}
              />
                </Grid> */}
      <TaskTabsModal
        showModal={openModal}
        setShowModal={(v) => setOpenModal(v)}
        loading={loading}
        projectID={projectID}
        taskID={taskID}
        handleChangeProject={(v) => setProjectID(v)}
        handleChangeTask={(v) => setTaskID(v)}
        refetch={refetchTimeSheet}
        fromProject={true}
        setType={(v) => type.current = v}
        type={type.current}
        open={JSON.parse(sessionStorage.getItem("unsavedChanges"))}
        modifyFormFlag={() =>
          sessionStorage.setItem("unsavedChanges", JSON.stringify(false))
        }
      />
      {openEditDialog && (
        <Dialog
          open={openEditDialog}
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
          onClose={() => {
            if (JSON.parse(sessionStorage.getItem("unsavedChanges")) === true) {
              setOpenEditDialog(true)
            }
            else {
              setOpenEditDialog(false);
              setTriggerTimesheetQuery(false)
            }
          }}
          sx={{
            ".MuiDialog-container .MuiPaper-root": {
              maxWidth: "600px !important",
              minWidth: "600px !important",
            },
          }}
        >
          <Grid container>
            <Grid
              id="draggable-dialog-title"
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 20px", // Adjust padding as needed
              }}
            >
              <Typography variant="h6">{t('myTimesheets.edit.description')}</Typography> {/* Title added here */}
              <IconButton
                onClick={() => {
                  if (JSON.parse(sessionStorage.getItem("unsavedChanges")) === true) {
                    setOpenEditDialog(true)
                  } else {
                    setOpenEditDialog(false);
                    setTriggerTimesheetQuery(false);
                  }
                }}
                sx={{ fontSize: "14px !important" }}
              >
                <CloseIcon color="inherit" />
              </IconButton>
            </Grid>
            <Grid item xs={12} sx={{ padding: "0 20px" }}> {/* Adjust padding to match the title's horizontal alignment */}
              <TextField
                size="large"
                multiline
                fullWidth
                variant="standard"
                value={description}
                sx={{
                  "& .MuiInputBase-input": {
                    textAlign: "left",
                    fontSize: "13px !important",
                    minHeight: "32px !important",
                  },
                  "& .MuiInputBase-root": {
                    paddingTop: "0 !important",
                    paddingBottom: "0 !important",
                  },
                }}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Grid>
            <Grid gap={2} item xs={12} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", padding: "20px" }}> {/* Padding adjusted */}
              <IALoadingButton
                label={t("employees.cancel.label")}
                onClick={() => { setOpenEditDialog(false); setTriggerTimesheetQuery(false) }}
              />
              <IALoadingButton
                label={t("employees.save.label")}
                onClick={handleUpdate}
              />
            </Grid>
          </Grid>
        </Dialog>

      )}
      {getColumnsLoading ? (
        <ContainerCard
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <CircularProgress />
        </ContainerCard>
      ) : (
        (
          <>

            <Box
              sx={{
                marginTop: {
                  xs: "0px !important",
                  sm: "0px !important",
                  md: "0px !important",
                  lg: "0px !important",
                  xl: "0px !important",
                },
              }}
            >

              <DataTable
                {...pagination}
                identifier="timeSheetGuid"
                hasCheckbox
                fromTimesheets
                rows={rows}
                heightClassName="table-height"
                isFixed
                singleSelect
              />

            </Box>
          </>
        )
      )}
    </div>
  );
};

export default MonthyTimesheet;